export enum DocumentCategoryOptionType {
  DrivingLicense = 1,
  NationalIdentityCard = 2,
  Other = 3,
  BankStatement = 11,
  TradingStatement = 23,
  ProofOfDeposit = 48,
}
